import { ConditionalRender, SplitText } from '@libs/core';
import { TCommonData, TWidget } from '@libs/types';
import React from 'react';
import { ErrorAnimation } from '../../../Animation/ErrorAnimation';
import { SuccessAnimation } from '../../../Animation/SuccessAnimation';
import { ModalWithTimer } from '../../../UI/ModalWithTimer/ModalWithTimer';
import { TextCommon } from '../../../UI/Text/TextCommon';

type TSuccessModal = {
    text: string;
    success?: boolean;
    /** Design version of the owning widget. */
    version: number | undefined;
};
export const InfoModal = ({ text, success = true, version }: TSuccessModal) => {
    const widget = { version, options: { margin: { left: 24, right: 24 } } } as TWidget<TCommonData>;
    return (
        <ModalWithTimer version={version}>
            <ConditionalRender condition={success}>
                <SuccessAnimation widget={widget} />
            </ConditionalRender>
            <ConditionalRender condition={!success}>
                <ErrorAnimation widget={widget} />
            </ConditionalRender>
            <TextCommon isWidget={false} as={'div'} options={{ margin: { top: 24 } }}>
                <SplitText text={text} as={'p'} />
            </TextCommon>
        </ModalWithTimer>
    );
};
